import type { IDepositTransaction } from "@/modules/deposit/common/types";
import { CURRENCY } from "@/shared/common/constants";
import { formatDate } from "@/shared/helpers";
import type { ICellProps } from "@ab.uitools/ui-library/components/AdvancedTable/types";
import { Text } from "@ab.uitools/ui-library/components/Text";

interface Props {
  t: (s: string) => string;
}

export const getColumns = ({ t }: Props) => ([
  {
    id: "creationDate",
    header: t("deposits.historyTable.date"),
    accessorKey: "creationDate",
    enableHiding: false,
    cell: ({ row }: ICellProps<IDepositTransaction>) => {
      const date = formatDate(row.original?.creationDate);
      return (
        <Text>{date}</Text>
      );
    }
  },
  {
    id: "description",
    header: t("deposits.historyTable.description"),
    accessorKey: "description",
    enableHiding: false,
  },
  {
    id: "amount",
    header: t("deposits.historyTable.amount"),
    accessorKey: "amount",
    enableHiding: false,
    cell: ({ row }: ICellProps<IDepositTransaction>) => {
      const amount = row.original?.amount;
      const currency = row.original?.currency;
      return (
        <Text>{`${amount} ${CURRENCY[currency]?.symbol}`}</Text>
      );
    },
  },
]);
